import Header from "../components/Header"
import "../Myprojects.css";
import api from "views/auth/Api";
import React, { useState,useEffect } from "react";
import FeedbackTrTable from "../../tables/components/FeedbackTrTable";
import {
  columnsDataDevelopment,
  columnsDataCheck,
  columnsDataColumns,
  columnsDataComplex,
} from "../../tables/variables/columnsData";


const SubmissionFeedback = (submission) => {
    const [tableData , setTableData] = useState([]); 

    console.log("submissssssssssssssssssion",submission.submission?.id)

    useEffect(()=>{ 
      setTableData(submission.submission?.submission);
    },[submission]);

const validFeedbacks = tableData.filter(f => typeof f.feedback?.points === "number");
const average =
  validFeedbacks.reduce((sum, item) => sum + item.feedback?.points, 0) /
  validFeedbacks.length || 0;

  const setNew = (newData) => {
    setTableData(newData);
  }
    
  return (
        <div className="flex flex-col items-center" >
      {/* <Header /> */}
      <div className="SubFeedFilter">
        {/* <h4 className="AssignmentsH4">Assignments 3</h4> */}
            <span className="filterByBtn filterByBtnHover" >Total Feedbacks: {validFeedbacks.length}/{tableData.length}</span>
            <span className="filterByBtn filterByBtnHover">Average Grades: {average.toFixed(1)}</span>
            {/* <div className="filterByBtn fliterMarSub">
            <MdOutlineSchool className="filterByicon"/>
            <span>Filter by class</span>
            <div className="dropdownImg"></div>
          </div> */}
      </div>
      <div className="tableDev">
   <FeedbackTrTable columnsData={columnsDataCheck}
                    table={tableData}
                    assignId={submission.submission?.id}
                    setNew={setNew}
                    /> 
             </div>
    </div>
  );
};

export default SubmissionFeedback;
